import { render } from "./AccountTrackerSettings.vue?vue&type=template&id=31232836"
import script from "./AccountTrackerSettings.vue?vue&type=script&lang=js"
export * from "./AccountTrackerSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__